<script setup lang="ts">
import './assets/style.scss'
</script>

<template>
  <div class="w-header__grid">
    <div class="w-header__user">
      <slot name="user" />
    </div>

    <div class="w-header__menu">
      <slot name="menu" />
    </div>
  </div>
</template>
